export const enNums = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
export const faNums = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
export const arNums = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];

export const enDigitsRegex = /[0-9]/g;
export const faDigitsRegex = /[۰۱۲۳۴۵۶۷۸۹]/g;
export const arDigitsRegex = /[٠١٢٣٤٥٦٧٨٩]/g;

export const digitsEnToFa = (value: string | number) => {
  if (typeof value !== 'string' && typeof value !== 'number')
    throw TypeError('PersianTools: digitsEnToFa - The input must be string or number');

  return String(value).replace(enDigitsRegex, (char) => `${faNums[Number(char)]}`);
};

export const digitsFaToEn = (value: string | number) => {
  if (typeof value !== 'string' && typeof value !== 'number') {
    throw TypeError('PersianTools: digitsFaToEn - The input must be string or number');
  }

  const combinedDigitsRegex = new RegExp(`(${faDigitsRegex.source}|${arDigitsRegex.source})`, 'g');

  return String(value).replace(combinedDigitsRegex, (char) => {
    const indexInFaNums = faNums.indexOf(char);
    if (indexInFaNums !== -1) {
      return enNums[indexInFaNums];
    }
    const indexInArNums = arNums.indexOf(char);
    if (indexInArNums !== -1) {
      return enNums[indexInArNums];
    }
    return char;
  });
};
